export enum FundingActivityStatus {
    Deposited = 'Deposited',
    InTansit = 'InTansit',
    Scheduled = 'Scheduled',
    Withdrawal = 'Withdrawal',
} 